import { Link } from 'react-router-dom';
import type { MovieItem } from '@/mocks/movies';

interface MovieCardProps {
  movie: MovieItem;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.slug}`}
      className="group block"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={movie.poster}
          alt={`${movie.title} - 鲁鲁影院高清在线观看`}
          title={`${movie.title} - 鲁鲁影院免费高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-xs text-foreground-200 line-clamp-3">{movie.description}</p>
        </div>
        {movie.isHot && (
          <div className="absolute top-2 left-2">
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded">热播</span>
          </div>
        )}
        {movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-primary-500 text-background-950 rounded">新</span>
          </div>
        )}
        <div className="absolute bottom-2 right-2">
          <span className="px-1.5 py-0.5 text-xs font-semibold bg-background-950/80 text-primary-400 rounded">
            {movie.rating}
          </span>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-background-950/70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-foreground-50 text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
        {movie.title}
      </h3>
      <div className="flex items-center gap-2 mt-1">
        <span className="text-xs text-foreground-500">{movie.category}</span>
        <span className="text-[10px] text-foreground-700">|</span>
        <span className="text-xs text-foreground-500">{movie.year}</span>
      </div>
    </Link>
  );
}